import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import RoyaltyPaymentForm from './forms/RoyaltyPaymentForm';
import RoyaltyPaymentList from './lists/RoyaltyPaymentList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import {Link} from "react-router-dom";
import urldecode from "locutus/php/url/urldecode";
import http_build_query from "locutus/php/url/http_build_query";
import InvoiceEditor from "./invoiceEditor";
import ModalEditor from "./ModalEditor";
import InvoiceList from "./lists/invoiceList";
import ComponentConfig from "../form/ComponentConfig";

class RoyaltyPaymentEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    getFieldProps = (name) => {
        const props = this.props.getFieldProps(name);
        props.disabled = props.disabled || !!this.props.values[this.props.componentConfig.idfield];
        return props;
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        const Other = this.props.other || Fragment;
        return <Fragment>
                <List
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header="Jogdíj kifizetések"
                >
                    <ComponentConfig componentName="invoice">
                        <InvoiceList ref={(el) => this.list = el} {...this.props} selection={(rows) => rows.find((row) => row.component_id + "" === "" + this.props.values[this.props.componentConfig.idfield])} filter={[{field: "component", value: this.props.componentConfig.componentname}]} loadForm={(data) => this.loadForm(data ? {[this.props.componentConfig.idfield]: data.component_id} : {})} />
                    </ComponentConfig>
                    {/*<RoyaltyPaymentList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />*/}
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header="Jogdíj kifizetés"
                >
                    <RoyaltyPaymentForm {...this.props} getFieldProps={this.getFieldProps} />
                </Editor>
            <Other>
                {this.props.values[this.props.componentConfig.idfield] && <InvoiceEditor
                    editorContext={this.props.componentConfig.componentname + "InvoiceEditor"}
                    gridid={this.props.componentConfig.componentname + "InvoiceList"}
                    pageSize={0}
                    listFilter={[
                        {
                            field: "component",
                            value: this.props.componentConfig.componentname
                        },{
                            field: "component_id",
                            value: this.props.values[this.props.componentConfig.idfield]
                        }
                    ]}
                    editor={ModalEditor}
                    selection={null}
                    onProcessAction={() => {
                        if (!this.props.isLoading) {
                            this.props.reloadForm && this.props.reloadForm();
                        }
                    }}
                />}
            </Other>
        </Fragment>;
    }
}

export default createEditor({
    componentName: "RoyaltyPayment",
    WrappedComponent: RoyaltyPaymentEditor,
    props: {
        view: "admin"
    }
});
